export default __webpack_public_path__ + "car_wash.900c91401bb536a2ea7673d06a237319.webp";